// Lib
import { FC } from "react";
import { RadioChangeEvent } from "antd";
// Types
import { ComboGroup, ComboGroupSubItem } from "types/customers";
// Helpers
import { fixedDigitsValue } from "helpers/dataHelpers";
// Components
import { CheckBoxLabel } from "../../../CheckBoxLabel";
// Styled
import { FlexContainer } from "styled/Box";
import { Typography } from "styled/Typography";
import { StyledCheckbox } from "pages/Orders/View/OrderCreate/styled";
import { RadioGroup } from "./styled";

interface CombosProps {
  comboGroup: ComboGroup;
  selectedCombos: Record<string, ComboGroupSubItem[]> | null;
  onComboCheck: ({
    comboGroupId,
    subItem,
    value,
    min,
    max,
  }: {
    comboGroupId: string;
    subItem: ComboGroupSubItem;
    value: boolean;
    min?: number;
    max?: number;
  }) => void;
}

export const Combos: FC<CombosProps> = ({
  comboGroup,
  selectedCombos,
  onComboCheck,
}) => {
  const onRadioClick = (e: RadioChangeEvent) => {
    const item = comboGroup?.subItems?.find(
      subItem => subItem?.id === e.target.value,
    );

    if (!item) {
      return;
    }

    onComboCheck({
      min: comboGroup.min,
      max: comboGroup.max,
      comboGroupId: comboGroup.id,
      subItem: item,
      value: true,
    });
  };

  if (comboGroup.min === 1 && comboGroup.max === 1) {
    const options = comboGroup?.subItems?.map(subItem => ({
      value: subItem.id,
      label: (
        <FlexContainer $fullwidth $justify="space-between" className="label">
          <Typography.Title>{subItem.name}</Typography.Title>

          <Typography.Title>{`KD ${fixedDigitsValue(
            subItem.fiatCentsPrice,
            3,
          )}`}</Typography.Title>
        </FlexContainer>
      ),
    }));

    return (
      <RadioGroup
        value={selectedCombos?.[comboGroup.id][0]?.id}
        options={options}
        onChange={onRadioClick}
      />
    );
  }

  return (
    <>
      {comboGroup?.subItems?.map(subItem => (
        <FlexContainer
          key={subItem.id}
          $gap={10}
          $align="center"
          $justify="space-between"
          $margin="0 0 4px 0"
        >
          <StyledCheckbox
            label={
              <CheckBoxLabel
                label={subItem.name}
                fmcPrice={subItem.fmcCentsPrice}
                fiatPrice={subItem.fiatCentsPrice}
              />
            }
            checked={selectedCombos?.[comboGroup.id]?.some(
              el => el.id === subItem.id,
            )}
            disabled={comboGroup.max === 0}
            onChange={e =>
              onComboCheck({
                min: comboGroup.min,
                max: comboGroup.max,
                comboGroupId: comboGroup.id,
                subItem,
                value: e.target.checked,
              })
            }
          />
        </FlexContainer>
      ))}
    </>
  );
};
